import ScrollReveal from "./ScrollReveal";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Marie L.",
    location: "Bourg-en-Bresse",
    text: "Résultat bluffant ! Ma cuisine a été transformée en 2 jours. On dirait une cuisine neuve. Je recommande vivement Vinylux.",
    avatar: "https://images.pexels.com/photos/18015900/pexels-photo-18015900.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stars: 5,
  },
  {
    name: "Thomas D.",
    location: "Lyon",
    text: "Très professionnel, travail soigné et rapport qualité/prix imbattable. On a économisé plus de 7000\u20AC par rapport à une cuisine neuve.",
    avatar: "https://images.pexels.com/photos/19838484/pexels-photo-19838484.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stars: 5,
  },
  {
    name: "Sophie M.",
    location: "Villefranche-sur-Saône",
    text: "Service impeccable du début à la fin. Le covering tient parfaitement même près de la plaque de cuisson. Merci Vinylux !",
    avatar: null,
    stars: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section data-testid="testimonials-section" className="py-24 lg:py-36 bg-[#0273DB]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <ScrollReveal>
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white mb-4">
              Ils nous font confiance
            </h2>
            <p className="text-base sm:text-lg text-white/70 leading-relaxed max-w-2xl mx-auto">
              Intervention dans tout le secteur autour de Sainte-Olive.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, idx) => (
            <ScrollReveal key={t.name} delay={idx * 0.1}>
              <div
                data-testid={`testimonial-${idx}`}
                className="bg-white/10 backdrop-blur-sm rounded-2xl p-7 border border-white/15 hover:-translate-y-1 hover:bg-white/15 transition-all duration-300 h-full flex flex-col"
              >
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: t.stars }).map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-white text-white" />
                  ))}
                </div>
                <p className="text-white/80 leading-relaxed flex-1 mb-5 text-sm">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3">
                  {t.avatar ? (
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover ring-2 ring-white/20"
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center text-white font-bold text-sm">
                      {t.name.charAt(0)}
                    </div>
                  )}
                  <div>
                    <div className="font-semibold text-white text-sm">{t.name}</div>
                    <div className="text-white/50 text-xs">{t.location}</div>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
